export default "__VITE_ASSET__c219c3af__"